import classStyle from './Toast.module.scss';

export default function Toast(props) {
    const { text } = props;

    return (
        <div className={classStyle.toastBack}>
            <div className={classStyle.toastCard}>
                <div className={classStyle.toastText}>{text}</div>
            </div>
        </div>
    );
}
